/**
 * @param {string|null} targetElement
 */
const resolveProductVariants = (targetElement = null) => {
  let s ='';

  if (targetElement) {
    s += `${targetElement} `;
  }

  s += `[data-module='variants']`;

  document.querySelectorAll(s).forEach((product) => updateProductView(
      product
  ));
};

/**
 * @param {object} variants
 * @param {object} product
 * @returns {object|null}
 */
const resolveVariant = (variants, product) => {
  const location = getLocation();

  const selectedVariant = variants.find((variant) => {
    if (!variant.available || variant.price === 0)  {
      return null;
    }

    return variant.stateCoverage.includes(location.state)
  });

  console.log('variant debug:', {
      product,
      location,
      variants,
      selectedVariant
  });

  return selectedVariant;
};

/**
 * @returns {{state: string}}
 */
const getLocation = () => {
  return {
    state: getCustomerState()
  };
};

/**
 * @param {object} product
 * @param {object|null} variant
 */
const updateProductView = (product, variant = null) => {
  if (!variant) {
    try {
      const variantList = JSON.parse(product.dataset.variants).sort((a, b) => Number(a.price) - Number(b.price));
      variant = resolveVariant(variantList, product);
      delete product.dataset.variants;
    } catch (e) {
      variant = undefined;
    }
  }

  setProductAvailability(product, variant);
};

/**
 * @param {object} product
 * @param {object} variant
 */
const setProductAvailability = (product, variant) => {
  if (!variant?.available || !variant?.price) {
    setProductOos(product);
    return;
  }

  setProductInStock(product, variant);
};

/**
 * @param {object} product
 */
const setProductOos = (product) => {
  const buyButton = product.querySelector('.product-form__submit');
  const priceContainer = product.querySelector('.price__container');

  if (buyButton) {
    buyButton.disabled = true;
  }

  if (priceContainer) {
    priceContainer.style.display = 'none';
  }
};

/**
 * @param {object} product
 * @param {object} variant
 */
const setProductInStock = (product, variant) => {
  const variantField = product.querySelector('[data-type=add-to-cart-form] [name=id]');
  const priceItem = product.querySelector('.price-item.price-item--regular');

  if (variantField) {
    variantField.value = variant.id;
  }

  if (priceItem) {
    priceItem.innerHTML = formatPrice(variant.price);
  }
};

/**
 * Check if element is a card or product details view
 * @param {object} product
 * @returns {boolean}
 */
const isCard = (product) => {
  return product.dataset.view == 'product_card';
};

/**
 * Check if element page is product details
 * @param {object} product
 * @returns {boolean}
 */
const isPdp = (product) => {
  return product.dataset.page == 'product';
};

/**
 * @param {object} product
 */
const removeLoader = (product) => {
  if (product.querySelector('.price-loader')) {
    product.querySelector('.price-loader').classList.remove('price-loader');
  }
  product.querySelectorAll('.btn-loader').forEach(e => e.classList.remove('btn-loader'));
};
